var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 29,
    rx: 20,
    ry: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.9881L10.8045 8H29.7071L36 13.9999V18.4997H4V13.9881ZM11.1955 9H29.2929L35 14.4141V17.4997H5V14.4259L11.1955 9Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7245 14.5C12.7051 14.5 13.5 15.2949 13.5 16.2755C13.5 17.2124 14.2393 18 15.1852 18H24.8148C25.7607 18 26.5 17.2124 26.5 16.2755C26.5 15.2949 27.2949 14.5 28.2755 14.5H35.5V27.7755C35.5 28.1911 35.1779 28.5 34.8148 28.5H5.18519C4.82206 28.5 4.5 28.1911 4.5 27.7755V14.5H11.7245Z",
    fill: "#F2F2F2",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.d0acd657.svg";
export { ForwardRef as ReactComponent };